var map = {
	"./breakarecord.jpg": 7418,
	"./cecyfoundation.png": 3684,
	"./cecyhealth.png": 6533,
	"./dark-bg.jpg": 7527,
	"./dictionary.jpg": 655,
	"./freeCodeCampjs.png": 3372,
	"./galaxies.jpg": 1471,
	"./my-img.jpeg": 8328,
	"./pc-25.png": 7916,
	"./project-dashboard.png": 3079,
	"./royalnet.png": 2313,
	"./sing-landing.jpg": 868,
	"./tcmp.png": 2107,
	"./tsg-admin.png": 4315,
	"./tsg.png": 1609,
	"./weather.png": 8799
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;